import { getLogger } from 'app-components/utils/core';
import { createAppSlice } from 'app-components/utils/redux-store/createAppSlice';

import { commonSelectors, createQcsThunks, createResourceEntityAdapter } from '../core/resourceSliceUtils';
import transactionRulesApi from './transactionRulesApi';
import type { TransactionRulesState, TransactionRuleType } from './transactionRulesTypes';
import { TRANSACTION_RULES_REDUCER_KEY } from './transactionRulesTypes';

// Define the initial state using that type
const initialState: TransactionRulesState = {
  entities: {},
  ids: [],
  isLoading: false,
  loadPending: true,
  error: null,
  lastSyncDate: null,
};
const log = getLogger('app-components/flux/transactionRules/transactionRulesSlice.ts');

const entityAdapter = createResourceEntityAdapter<TransactionRuleType>();
const entitySelectors = entityAdapter.getSelectors();

export const slice = createAppSlice({
  name: TRANSACTION_RULES_REDUCER_KEY,
  initialState: entityAdapter.getInitialState(initialState),
  reducers: (create) =>
    createQcsThunks({
      create,
      refetch(dispatch) {
        dispatch(transactionRulesActions.fetch());
      },
      // @ts-expect-error TS2322
      api: transactionRulesApi,
      adapter: entityAdapter,
      log,
    }),
  selectors: {
    ...entitySelectors,
    ...commonSelectors,
  },
});

export const transactionRulesActions = slice.actions;
export const transactionRulesSelectors = slice.selectors;
export { slice as transactionRulesSlice };

export default slice.reducer;
